import { Trans } from 'i18n'
import styled from 'lib/styled-components'
import { ThemedText } from 'theme/components'

const Divider = styled.div`
  width: 100%;
  height: 1px;
  border-width: 0;
  margin: 12px 0;
  background-color: ${({ theme }) => theme.surface3};
`

// Robinhood Chain (4663) swaps go through the first-party router, which is exact-input only, so the
// "Buy" amount can't be typed directly. Shown when the user clicks the disabled output field there.
export function ExactInputOnlyTooltipBody() {
  return (
    <ThemedText.LabelMicro color="textPrimary">
      This chain supports exact-input swaps only. Enter the amount you want to sell and the buy amount
      is quoted for you.
    </ThemedText.LabelMicro>
  )
}

export function OutputTaxTooltipBody({ currencySymbol }: { currencySymbol?: string }) {
  return (
    <>
      <ThemedText.SubHeaderSmall color="textPrimary">
        <Trans i18nKey="swap.taxTooltip.label" />
      </ThemedText.SubHeaderSmall>
      <Divider />
      <ThemedText.LabelMicro color="textPrimary">
        {currencySymbol ? (
          <Trans i18nKey="swap.taxTooltip.tokenSelected" values={{ tokenSymbol: currencySymbol }} />
        ) : (
          <Trans i18nKey="swap.taxTooltip.noTokenSelected" />
        )}
      </ThemedText.LabelMicro>
    </>
  )
}
